(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-data/teams/assets/javascripts/services/end-team.js') >= 0) return;  svs.modules.push('/components/marketplace-data/teams/assets/javascripts/services/end-team.js');
"use strict";


const jupiter = svs.core.jupiter;
const endTeam = function (groupId) {
  let callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : () => {};
  if (typeof groupId !== 'number') {
    throw new Error("groupId: ".concat(groupId, " was not a number"));
  }
  jupiter.delete("/marketplace/1/groups/".concat(groupId), () => {
    callback();
  }, error => {
    callback(error.responseJSON.error);
  });
};
setGlobal('svs.components.marketplaceData.teams.services.endTeam', endTeam);

 })(window);